import * as constants from '../../constants'

export const FAILURE = `GET_SETTINGS_${constants.FAILURE}`
export const PENDING = `GET_SETTINGS_${constants.PENDING}`
export const SUCCESS = `GET_SETTINGS_${constants.SUCCESS}`
